import { Blockquote, Text } from "@radix-ui/themes";
import { formatCurrencyFromCents } from "use-smart-locks-shared";
import { useUnit } from "../../hooks/use-unit";

export const MeteredPricing: React.FC = () => {
  const unit = useUnit();

  return (
    <>
      <Text>Die Abrechnung erfolgt minutengenau mit günstigen:</Text>

      <Blockquote>
        {formatCurrencyFromCents(unit.pricePerMinuteInCents ?? 0)} pro Minute
      </Blockquote>

      {unit.basePriceInCents != null && unit.basePriceInCents > 0 && (
        <Blockquote>
          Die Abrechnung startet mit einer Grundgebühr von{" "}
          {formatCurrencyFromCents(unit.basePriceInCents)}
        </Blockquote>
      )}

      {unit.maxTotalPriceInCents != null && unit.maxTotalPriceInCents > 0 && (
        <Blockquote>
          Maximal zahlen Sie{" "}
          {formatCurrencyFromCents(unit.maxTotalPriceInCents)} pro Buchung
        </Blockquote>
      )}

      {unit.freeMinutes != null && unit.freeMinutes > 0 && (
        <Blockquote>
          Die ersten {unit.freeMinutes} Minuten sind sogar kostenlos!
        </Blockquote>
      )}

      <Text>
        Zur Buchung müssen Sie ein Zahlungsmittel hinterlegen. Wir belasten dies
        dann nach Rückgabe mit der Abrechnung, die
        {unit.basePriceInCents ? " bei der Grundgebühr startet und " : " "}
        minutengenau weiterläuft
        {unit.maxTotalPriceInCents
          ? " bis maximal zum angegebenen Höchstbetrag."
          : "."}
      </Text>
    </>
  );
};
